//@ts-nocheck
import { defineMessages } from 'react-intl';

export default defineMessages({
  EXPAND_SIDEBAR: 'Expand sidebar',
  COLLAPSE_SIDEBAR: 'Collapse sidebar',
  CHAT_WITH_SUPPORT: 'Chat with support',
  ECHO_TOGGLE_LABEL: 'Toggle support assistant',
});
